import { OptionalCreatePageReference } from '@databases/types/confluence';
import { DatabaseField, DatabaseFieldType } from '@databases/types/database';
import { DatabaseChangeType } from '@databases/utils/database/changesets';
import { getDatabaseFieldRequired } from '@databases/utils/database/utils';
import { addContentToList } from '@databases/utils/redux/content/actions';
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { addChangeToDraft, setDraftedChangeset } from '../changesets/actions';
import {
  selectDatabaseDraftByContentId,
  selectDraftedChangeset,
} from '../changesets/selectors';
import { createParentPage } from '../createParentPage';
import { DefaultRootState } from '../redux';
type Dispatcher<Result> = ThunkAction<Result, DefaultRootState, void, AnyAction>;

export const doCreateField =
  (
    contentId: string,
    parentScope: string,
    scope: string,
    fieldId: string
  ): Dispatcher<Promise<DatabaseField>> =>
  async (dispatch, getState) => {
    const databaseDraft = selectDatabaseDraftByContentId(getState(), {
      contentId,
      scope,
      includeDeleted: false,
    });
    const field = getDatabaseFieldRequired(databaseDraft, fieldId);

    // Create parent page if needed
    const parentPage =
      field.type === DatabaseFieldType.PAGE_LINK
        ? (field.settings.parentPage as OptionalCreatePageReference)
        : undefined;
    if (parentPage?.create) {
      const newPage = await createParentPage(databaseDraft, parentPage);
      if (newPage) {
        dispatch(addContentToList(newPage));
        dispatch(
          addChangeToDraft(contentId, scope, {
            type: DatabaseChangeType.SET_PARENT_PAGE,
            fieldId,
            newParentPage: {
              type: 'page',
              spaceKey: newPage.space!.key,
              contentTitle: newPage.title,
              contentId: newPage.id,
            },
          })
        );
      }
    }

    const changeset = selectDraftedChangeset(getState(), { contentId, scope });
    dispatch(setDraftedChangeset(contentId, parentScope, changeset));

    return field;
  };
